import React from "react";
import styled from "styled-components";

import { translations } from "../../utils/translations.js";
import { useSelector } from "react-redux";
import InputField from "./core-components/InputField.tsx";
import Button from "./core-components/Button.tsx";
import { FaStar, FaRegStar } from "react-icons/fa6";
import { addReview } from "../../services/productsService.js";
import { useAuth } from "../../hooks/useAuth.jsx";

const FormContainer = styled.div`
  display: flex;
  width: 70%;
  flex-direction: column;
  gap: 16px;

  align-self: center;
  padding: 12px;
  margin-bottom: 8px;
`;
const Header = styled.h4`
  color: var(--primary-brown);
  margin: 0;
`;

const StarsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

const StarButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font-size: 14px;
`;

interface Props {
  productID: string;
  clientID: string;
  onClosed: (string) => void;
}

const ReviewForm: React.FC<Props> = ({ productID, clientID, onClosed }) => {
  const languageCode = useSelector((state: any) => state.settings.languageCode);
  const [selectedRating, setSelectedRating] = React.useState(0);
  const [message, setMessage] = React.useState("");
  const { token } = useAuth();
  const handleStarClick = (index: number) => {
    setSelectedRating(index + 1);
  };
  const handleSubmit = async () => {
    const review = {
      starNumber: selectedRating,
      message: message,
      date: new Date().toISOString(),
      productID,
      clientID,
    };

    try {
      await addReview(review, token);
      onClosed("success");
    } catch (error) {
      onClosed("error");
      console.error("Error creating type:", error);
    }

    setMessage("");
    setSelectedRating(0);
  };
  return (
    <FormContainer>
      <Header>{translations[languageCode]["revie-open-form"]}</Header>
      <StarsContainer>
        {Array.from({ length: 5 }).map((_, index) => (
          <StarButton key={index} onClick={() => handleStarClick(index)}>
            {index < selectedRating ? (
              <FaStar style={{ fill: "var(--primary-brown)" }} />
            ) : (
              <FaRegStar style={{ fill: "var(--primary-brown)" }} />
            )}
          </StarButton>
        ))}
      </StarsContainer>

      <InputField
        name="code"
        type="textarea"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder={translations[languageCode]["reviews-msg"]}
        isRequired
      />
      <Button
        id="save-review"
        onClick={handleSubmit}
        text="Save"
        backgroundColor={"var(--primary-brown)"}
        color="white"
      />
    </FormContainer>
  );
};

export default ReviewForm;
